import { memo, useContext } from 'react';
import {
    FaCheck, FaCheckDouble, FaMagnifyingGlass, FaRegCalendarCheck, FaToggleOn
} from 'react-icons/fa6';
import { HiX } from 'react-icons/hi';
import { MdDateRange } from 'react-icons/md';

import { filter_types } from '../../interfaces/ServerInterfaces';
import { FilterOpts, TableContext } from '../misc/GenericTable';

// Optimización de getFilterIcon usando un objeto de mapeo
const filterIcons: Record<filter_types, JSX.Element> = {
  boolean: <FaToggleOn />,
  input: <FaMagnifyingGlass />,
  select: <FaCheck />,
  multiselect: <FaCheckDouble />,
  datepicker: <FaRegCalendarCheck />,
  'price-range': <></>,
  'datepicker-range': <MdDateRange />,
  number: <FaMagnifyingGlass />,
}

export const getFilterIcon = (type: filter_types) => filterIcons[type] ?? <></>

interface FilterComponentInt {
  availableFilters: FilterOpts[]
  filterAction: Function
}

// Función auxiliar para encontrar un filtro específico
const findFilterItem = (filter: any, availableFilters: FilterOpts[]) => {
  return availableFilters.find((item) => {
    if (item.format === 'datepicker-range') {
      return item?.datepickerRange?.some(
        (newItem) => newItem?.filterCode === filter.id
      )
    } else if (item.format === 'price-range') {
      return item?.priceRange?.some((price) => price?.filterCode === filter.id)
    } else {
      return item.filterCode === filter.id
    }
  })
}

// Componente optimizado
const FilterBadge = memo(
  ({
    filterComponent,
  }: {
    filterComponent: FilterComponentInt | undefined
  }) => {
    const { selectedFilter, setSelectedFilter } = useContext(TableContext)
    const removeFilter = (idx: number) => {
      const newFilter = [...selectedFilter!]
      newFilter.splice(idx, 1)
      setSelectedFilter!(newFilter)
      filterComponent?.filterAction(
        newFilter.reduce(
          (acc, { id, name }) => {
            acc[id] = name
            return acc
          },
          {} as Record<string, any>
        )
      )
    }

    return (
      <div className="flex flex-wrap gap-2 p-2">
        {selectedFilter?.map((filter, idx) => {
          const findedItem = findFilterItem(
            filter,
            filterComponent?.availableFilters || []
          )
          const dateRangeName =
            findedItem?.datepickerRange?.find(
              (fitem) => fitem.filterCode === filter.id
            )?.name || ''
          const priceRangeName =
            findedItem?.priceRange?.find(
              (price) => price.filterCode === filter.id
            )?.name || ''
          const filterValue = filter.value

          const format = findedItem?.format

          const selectedItem =
            format !== 'boolean'
              ? format !== 'input' && format !== 'number'
                ? format !== 'multiselect'
                  ? format !== 'select'
                    ? format !== 'datepicker-range'
                      ? format !== 'price-range'
                        ? format !== 'datepicker'
                          ? (findedItem?.data![0]?.name ?? '')
                          : (filter?.name ?? '')
                        : (filter?.name ?? '')
                      : (filter.name ?? '')
                    : (findedItem?.data?.find(
                        (item: any) =>
                          item.id ===
                          selectedFilter?.find(
                            (slcFilter) =>
                              slcFilter.id === findedItem.filterCode
                          )?.value!
                      )?.name ?? '')
                  :filterValue.map((item: string) => {
                    return findedItem?.data?.find(i => i.id === item)?.name
                  })
                : filterValue
              : null

          return (
            <div
              key={idx}
              className="group relative inline-flex items-center gap-1 rounded-full bg-slate-500 py-1 pl-5 pr-8 text-xs font-semibold italic text-white"
            >
              {getFilterIcon((filter?.description! as filter_types) ?? '')}
              <p>
                {`${findedItem?.name ?? ''} ${dateRangeName} ${priceRangeName}`}
                {!!selectedItem ? `: ${selectedItem}` : ''}
              </p>
              <HiX
                className="absolute right-2 hidden cursor-pointer text-lg group-hover:block"
                onClick={() => removeFilter(idx)}
              />
            </div>
          )
        })}
      </div>
    )
  }
)

export default FilterBadge
